import React from "react";
import { Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BasicTable from "./Tabla";
import CodeContent from "./CodeContent";
import TabLenguaje from "./TabLenguaje";
import EndpointContent from "./EndpointContent";
import TablaTipoComprobante from './TablaTipoComprobante';

function createData(
    campo,
    Tipo,
    valorEjemplo,
    Descripcion
) {
    return { campo, Tipo, valorEjemplo, Descripcion };
}

const Resend = () => {
    const [t] = useTranslation('global');
    const cCurl =
    `  
        curl --location --request PUT 'https://wsventas-p1.rapifac.com/v0/comprobantes/reenviar?ID=92928&Regenerar=1'
        --header 'Authorization: Bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9...'
        `;
  const csRS =
        `   
        var options = new RestClientOptions("https://wsventas-p1.rapifac.com")
        {
        MaxTimeout = -1,
        };
        var client = new RestClient(options);
        var request = new RestRequest("/v0/comprobantes/reenviar?ID=92928&Regenerar=1", Method.Put);
        request.AddHeader("Authorization", "Bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9");
        RestResponse response = await client.ExecuteAsync(request);
        Console.WriteLine(response.Content);
          `;
  const javaOK =
    `        
        OkHttpClient client = new OkHttpClient().newBuilder()
            .build();
        MediaType mediaType = MediaType.parse("text/plain");
        RequestBody body = RequestBody.create(mediaType, "");
        Request request = new Request.Builder()
            .url("https://wsventas-p1.rapifac.com/v0/comprobantes/reenviar?ID=92928&Regenerar=1")
            .method("PUT", body)
            .addHeader("Authorization", "Bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9...")
            .build();
        Response response = client.newCall(request).execute();
            `
    ;
  const phpHC =
    `
        <?php
            require_once 'HTTP/Request2.php';
            $request = new HTTP_Request2();
            $request->setUrl('https://wsventas-p1.rapifac.com/v0/comprobantes?documento=97&desde=01/02/2023&hasta=21/02/2023&busqueda=&sucursal=20190306&usuario=20190306&pagina=1');
            $request->setMethod(HTTP_Request2::METHOD_GET);
            $request->setConfig(array(
            'follow_redirects' => TRUE
            ));
            $request->setHeader(array(
            'Authorization' => 'Bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htb...'
            ));
            try {
            $response = $request->send();
            if ($response->getStatus() == 200) {
                echo $response->getBody();
            }
            else {
                echo 'Unexpected HTTP status: ' . $response->getStatus() . ' ' .
                $response->getReasonPhrase();
            }
            }
            catch(HTTP_Request2_Exception $e) {
            echo 'Error: ' . $e->getMessage();
        }
    `;
  const csHTC =
    `         
        var client = new HttpClient();
        var request = new HttpRequestMessage(HttpMethod.Put, "https://wsventas-p1.rapifac.com/v0/comprobantes/reenviar?ID=92928&Regenerar=1");
        request.Headers.Add("Authorization", "Bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9...");
        var response = await client.SendAsync(request);
        response.EnsureSuccessStatusCode();
        Console.WriteLine(await response.Content.ReadAsStringAsync());
    
        
          `;
  const javaUNI =
    `        
        Unirest.setTimeouts(0, 0);
        HttpResponse<String> response = Unirest.put("https://wsventas-p1.rapifac.com/v0/comprobantes/reenviar?ID=92928&Regenerar=1")
        .header("Authorization", "Bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9...")
        .asString();
    `;
  const phpGZ =
    `     
    <?php
    $client = new Client();
    $headers = [
      'Authorization' => 'Bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9...'
    ];
    $request = new Request('PUT', 'https://wsventas-p1.rapifac.com/v0/comprobantes/reenviar?ID=92928&Regenerar=1', $headers);
    $res = $client->sendAsync($request)->wait();
    echo $res->getBody();    
    `;
    const codeResponseFactura =
    `
    {
        "xml_pdf": {
            "IDComprobante": 92811,
            "Codigo": 0,
            "IDRepositorio": "sS4BjwvWGQ...",
            "Firma": "+cnh+ydIm3ANl1vgsiS2...",
            "Mensaje": ""
        },
        "cdr": {
            "IDComprobante": 92811,
            "Codigo": 0,
            "IDRepositorio": "sS4BjwvWGQqz...",
            "Firma": "",
            "Mensaje": "La Factura numero F001-1, ha sido aceptada"
        }
    }
    `;
    const codeResponseBoleta =
    `
    {
        "xml_pdf": {
            "IDComprobante": 92812,
            "Codigo": 0,
            "IDRepositorio": "sS4BjwvWGQ...",
            "Firma": "+cnh+ydIm3ANl1vgsiS2...",
            "Mensaje": ""
        },
        "cdr": {
            "IDComprobante": 92812,
            "Codigo": 0,
            "IDRepositorio": "sS4BjwvWGQqz...",
            "Firma": "",
            "Mensaje": "La Boleta numero B001-1, ha sido aceptada"
        }
    }
    `;
    const codeResponseNotaCredito =
    `
    {
        "xml_pdf": {
            "IDComprobante": 92813,
            "Codigo": 0,
            "IDRepositorio": "sS4BjwvWGQ...",
            "Firma": "+cnh+ydIm3ANl1vgsiS2...",
            "Mensaje": ""
        },
        "cdr": {
            "IDComprobante": 92813,
            "Codigo": 0,
            "IDRepositorio": "sS4BjwvWGQqz...",
            "Firma": "",
            "Mensaje": "La Nota de Crédito numero FC01-1, ha sido aceptada"
        }
    }
    `;
    const codeResponseNotaDebito =
    `
    {
        "xml_pdf": {
            "IDComprobante": 92814,
            "Codigo": 0,
            "IDRepositorio": "sS4BjwvWGQ...",
            "Firma": "+cnh+ydIm3ANl1vgsiS2...",
            "Mensaje": ""
        },
        "cdr": {
            "IDComprobante": 92814,
            "Codigo": 0,
            "IDRepositorio": "sS4BjwvWGQqz...",
            "Firma": "",
            "Mensaje": "La Nota de Debito FD01-1, ha sido aceptada"
        }
    }
    `;
    const rows = [
        createData('ID', "Int", "92811", t('content.reenviar.descripcionID')),
        createData('Regenerar', "Int", "1", t('content.reenviar.descripcionRegenerar')),
    ];
    return (
        <div id="resend">
            <Divider sx={{ height: '70px' }} />
            <Typography variant="h3" id="reenviarComprobante" gutterBottom>
                {t('content.reenviar.titulo')}
            </Typography>
            <Typography variant="h5" gutterBottom>
                {t('content.reenviar.subtitulo')}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {t('content.reenviar.descripcion')}
            </Typography>
            <EndpointContent method='PUT' path='https://wsventas-p1.rapifac.com/v0/comprobantes/reenviar'/>
            <TabLenguaje curl={cCurl} csRS ={csRS} javaOK={javaOK} phpRQ={phpHC} csHC={csHTC} java2UN={javaUNI} php2GZ={phpGZ} />
            <br id={"reenviarObjeto"}/>
            <br/>
            <br/>
            <Typography variant="h5" gutterBottom>
                {t('content.reenviar.subtituloRespuesta')}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {t('content.reenviar.descripcion3')}
            </Typography>
            {/*<CodeContent code={codeResponse} languajeCode='json' />*/}
            <TablaTipoComprobante Factura={codeResponseFactura} NombreFactura={t('content.factura.titulo')} Boleta={codeResponseBoleta} NombreBoleta={t('content.boleta.titulo')} NotaCredito={codeResponseNotaCredito} NombreNotaCredito={t('content.notaCredito.titulo')} NotaDebito={codeResponseNotaDebito} NombreNotaDebito={t('content.notaDebito.titulo')}></TablaTipoComprobante> 
            <br id={"reenviarDescripcion"}/>
            <br/>
            <br/>
            <Typography variant="h5" gutterBottom>
                {t('content.reenviar.subtituloDescripcion')}
            </Typography>
            <BasicTable rows={rows} />

        </div>
    )
}

export default Resend;